var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 20.705 20.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradientinsta",
    x1: -1.092,
    y1: -2.861,
    x2: -0.436,
    y2: -2.106,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#f58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#f58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#f58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#f58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#f58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#f58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#f58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58220"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(-160.238 -4370.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M123.856,389.395a10.353,10.353,0,1,0,10.353,10.355A10.354,10.354,0,0,0,123.856,389.395Z",
    transform: "translate(46.734 3980.649)",
    fill: "#f58220"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M123.856,389.395a10.353,10.353,0,1,0,10.353,10.355A10.354,10.354,0,0,0,123.856,389.395Z",
    transform: "translate(46.734 3980.649)",
    fill: "url(#linear-gradientinsta)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M164.823,433.795Zm5.926-10.494h0Z",
    transform: "translate(2.804 3951.625)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M163.422,443.02a3.7,3.7,0,1,0-3.7-3.7A3.7,3.7,0,0,0,163.422,443.02Zm-2.8-3.7a2.8,2.8,0,1,1,2.8,2.8A2.8,2.8,0,0,1,160.622,439.324Z",
    transform: "translate(7.168 3941.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M152.247,430.935h-7.374a2.513,2.513,0,0,1-2.51-2.51v-7.262a2.513,2.513,0,0,1,2.51-2.51h7.374a2.513,2.513,0,0,1,2.51,2.51v7.262A2.513,2.513,0,0,1,152.247,430.935Zm-7.374-11.366a1.6,1.6,0,0,0-1.594,1.594v7.262a1.6,1.6,0,0,0,1.594,1.594h7.374a1.6,1.6,0,0,0,1.594-1.594v-7.262a1.6,1.6,0,0,0-1.594-1.594Z",
    transform: "translate(22.03 3955.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M207.957,432.7a.584.584,0,1,0,.584.584A.584.584,0,0,0,207.957,432.7Z",
    transform: "translate(-33.619 3943.582)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstgram);
export default __webpack_public_path__ + "static/media/instgram.83b5c5ba4be817ce1d8aa72690df01f9.svg";
export { ForwardRef as ReactComponent };